"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var util_1 = require("../styles/util");

var styles = function styles(_ref) {
  var _truncate, _truncateLastStep;

  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      shadows = _ref.shadows,
      spacing = _ref.spacing;
  return createStyles_1.createStyles({
    root: {
      counterReset: 'stepper',
      listStyleType: 'none',
      display: 'flex',
      justifyContent: 'space-around',
      padding: 0,
      margin: 0
    },
    contained: {
      padding: spacing(4),
      border: '1px solid rgba(0, 0, 0, 0.17)',
      boxShadow: shadows[1]
    },
    mini: {},
    dark: {},
    truncate: (_truncate = {}, _truncate[breakpoints.down('xs')] = {
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      '&::before': {
        content: 'attr(data-current)',
        marginLeft: 'auto',
        marginTop: '-0.75em',
        color: palette.primary.main,
        fontWeight: 600,
        order: 50
      },
      '&::after': {
        content: '"Next: " attr(data-next)',
        marginTop: '-0.25em',
        color: palette.text.secondary,
        fontSize: '0.9rem',
        order: 100,
        alignSelf: 'flex-end',
        flexGrow: 1,
        flexBasis: '100%',
        textAlign: 'right'
      }
    }, _truncate),
    truncateLastStep: (_truncateLastStep = {}, _truncateLastStep[breakpoints.down('xs')] = {
      '&::after': {
        content: '"Done"'
      }
    }, _truncateLastStep)
  });
};

var Stepper = React.forwardRef(function (props, ref) {
  var _clsx_1$default;

  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      _props$labelLocation = props.labelLocation,
      labelLocation = _props$labelLocation === void 0 ? 'right' : _props$labelLocation,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$contained = props.contained,
      contained = _props$contained === void 0 ? false : _props$contained,
      _props$truncate = props.truncate,
      truncate = _props$truncate === void 0 ? false : _props$truncate,
      _props$type = props.type,
      type = _props$type === void 0 ? 'interactive' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'light' : _props$variant,
      margin = props.margin,
      padding = props.padding,
      other = __rest(props, ["activeStep", "labelLocation", "children", "classes", "className", "contained", "truncate", "type", "variant", "margin", "padding"]);

  var _React$useState = React.useState(''),
      currentTitle = _React$useState[0],
      setCurrentTitle = _React$useState[1];

  var _React$useState2 = React.useState(''),
      nextTitle = _React$useState2[0],
      setNextTitle = _React$useState2[1];

  var rootClasses = clsx_1.default(classes.root, (_clsx_1$default = {}, _clsx_1$default[classes.contained] = contained, _clsx_1$default[classes.truncate] = truncate, _clsx_1$default), util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }), className);
  var childrenArray = React.Children.toArray(children);

  if (activeStep + 1 === childrenArray.length) {
    rootClasses = rootClasses + " " + classes.truncateLastStep;
  }

  var steps = childrenArray.map(function (step, index) {
    var last = index + 1 === childrenArray.length;
    var controlProps = {
      last: last,
      labelLocation: labelLocation,
      truncate: truncate,
      type: type,
      variant: variant,
      setCurrentTitle: setCurrentTitle,
      setNextTitle: setNextTitle
    };
    var state = {
      index: index,
      current: false,
      next: false,
      completed: false
    };

    if (activeStep === index) {
      state.current = true;
    } else if (!last && activeStep > index) {
      state.completed = true;
    }

    if (index === activeStep + 1) {
      state.next = true;
    }

    return [React.cloneElement(step, Object.assign(Object.assign(Object.assign({}, controlProps), state), step.props))];
  });
  return React.createElement("ol", Object.assign({
    className: rootClasses,
    "data-current": currentTitle,
    "data-next": nextTitle,
    ref: ref
  }, other), steps);
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiStepper'
})(Stepper);